export default "__VITE_PUBLIC_ASSET__2cb9468b__"